(function(app) {

    app.provider("userDelegateApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.getPermissions = function (userDelegateId) {
                        return portalApiGateway.get("/UserDelegates/" + userDelegateId + "/Permissions");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app);